define([
	"dojo/_base/declare",
	"csi/expander/Widget",
	"csi/middleware/customView/options/DataSheetTableOptionsStore",
	"csi/middleware/customView/options/DataSheetTableOptionsTab",
	"./DataSheetTablePreferences",

	"csi/heading/StringRich"	// needed to render comments
], function(declare, Widget, DataSheetTableOptionsStore, DataSheetTableOptionsTab, DataSheetTablePreferences) {

	return declare(Widget, {
		customViewOptionsComponent: DataSheetTableOptionsTab,
		customViewOptionsStore: DataSheetTableOptionsStore,
		prefClass: DataSheetTablePreferences,

		// Boolean: use displayCommentLines option rather than more general expandLevel, although may be overridden in some cases
		bSupportsExpandLevelOption: false,

		// Boolean: indicates if comment lines should be displayed when view first loaded
		//displayCommentLines: false,

		/*
		* @override
		* Remove the expandLevel option if not supported.
		*/
		onCreateDefaultCustomView(cv) {
			this.inherited(arguments);

			if (this.bSupportsExpandLevelOption) {
				cv.removeCustomOption("displayCommentLines");
			}
		},

		/*
		 * @override
		 * Set the expandLevel based on whether or not displayCommentLines custom view option is set.
		 */
		onViewPreferences() {
			this.inherited(arguments);

			const {bSupportsExpandLevelOption, displayCommentLines} = this;
			if (!bSupportsExpandLevelOption) {
				this.set("expandLevel", displayCommentLines ? 2 : 1);
			}
		}
	});
});